import {
  SET_IS_FOOD_TICKETS,
  SET_FOOD_TICKETS_DATA
} from '../constants/actionTypes/foodTickets';

/* Api */
import { getMonthlyFoodTickets } from '../utils/apiFoodTickets';

export const setIsFoodTickets = (dispatch, state) => {
  dispatch({
    type: SET_IS_FOOD_TICKETS,
    isFoodTickets: state
  });
};

export const setFoodTicketsData = (dispatch, month, year) =>
  new Promise(resolved => {
    getMonthlyFoodTickets(month + 1, year)
      .then(response => {
        const { dailyUses, available, used } = response;
        const listFromData = Object.entries(dailyUses).reduce((prev, post) => {
          const day = new Date(post[0]);
          const hours = post[1].map(item => ({
            title: item.substring(0, item.lastIndexOf(':')),
            start: day,
            end: day
          }));

          prev.push(hours);
          return prev;
        }, []);

        const dailyUsesUpdated = listFromData
          .reduce((prev, post) => prev.concat(post), [])
          .map((item, index) => ({ ...item, id: index }));

        const dataUpdated = {
          dailyUses: dailyUsesUpdated,
          available,
          used
        };

        dispatch({
          type: SET_FOOD_TICKETS_DATA,
          foodTicketsData: dataUpdated
        });

        resolved(dataUpdated);
      })
      .catch(error => {
        throw error;
      });
  });
